import {useLazyQuery} from '@apollo/client'
import {useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {GET_COMISSIONS_RATE_BY_OPERATOR, GET_ONE_CARRIER} from '../../gql/queries/carriersQuery'
import {
  ICarriersOperator,
  ICommissionRate,
  IResCommissionsRate,
  IResFileExcel,
} from '../../types/carriers'
import {toast} from 'react-toastify'
import {useGetUser} from '../../store/userStore'
import {Breadcrumb, Button, ButtonGroup, Col, Row, Spinner} from 'react-bootstrap'
import moment from 'moment'
// import {URL} from '../../gql/client'
import {parsePrice} from '../../helpers'
import {useDisclourse} from '../../hooks/useDisclourse'
// import {UPLOAD_EXCEL_STR} from '../../gql/mutations/carriersMutations'
import {useUploadFile} from '../../hooks/useUploadFile'
import {ModalAddCommissionRate} from './components/ModalAddCommissionRate'
import {ModalDeleteCommissionRate} from './components/ModalDeleteCommissionRate'
// import {ModalAddCommission} from './components/ModalAddCommissionRate'

export const OneComissionRate = () => {
  const [gqlGetComRateByOperator, {data, loading, error, refetch}] =
    useLazyQuery<IResCommissionsRate>(GET_COMISSIONS_RATE_BY_OPERATOR, {
      fetchPolicy: 'no-cache',
    })
  const [gqlGetCarrier, {data: dataCarrier, loading: loadingCarrier, error: errorCarrier}] =
    useLazyQuery<ICarriersOperator>(GET_ONE_CARRIER, {
      fetchPolicy: 'no-cache',
    })

  const [uploadFile, {data: dataFile, error: errorFile, loading: loadingFile}] =
    useUploadFile<IResFileExcel>()

  // const fileInputRef = useRef<HTMLInputElement>(null)

  const navigate = useNavigate()
  const {id} = useParams()
  // const [loadingExport, setLoadingExport] = useState(false)

  const [info, setInfo] = useState<ICommissionRate | null>(null)

  const {isOpen: isOpenAdd, onClose: onCloseAdd, onOpen: onOpenAdd} = useDisclourse()
  const {isOpen: isOpenDelete, onClose: onCloseDelete, onOpen: onOpenDelete} = useDisclourse()
  const {isOpen: isOpenEdit, onClose: onCloseEdit, onOpen: onOpenEdit} = useDisclourse()

  useEffect(() => {
    if (!id) {
      return navigate('/')
    }
    if (Number(id)) {
      gqlGetCarrier({
        variables: {
          id: '' + id,
        },
      })
      gqlGetComRateByOperator({
        variables: {
          carrierId: id,
        },
      })
      return
    }
    navigate('/')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  useEffect(() => {
    if (errorCarrier) toast.error(`Error: ${errorCarrier.message}`)
  }, [errorCarrier])
  useEffect(() => {
    if (error) toast.error(`Error: ${error.message}`)
  }, [error])
  useEffect(() => {
    if (errorFile) toast.error(`Error: ${errorFile}`)
  }, [errorFile])

  useEffect(() => {
    if (!dataFile) return
    if (dataFile.UpdateCommissionMutation.success) {
      toast.success('File uploaded successfully')
      refetch()
    } else {
      toast.error(`Error: ${dataFile.UpdateCommissionMutation.message || 'something wrong!'}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataFile])


  const carrier = dataCarrier?.insuranceOperatorById

  return (
    <>
      <div className='policies-page'>
        <header className='d-flex align-items-center flex-column flex-md-row justify-content-between mb-4'>
          <Breadcrumb>
            <Breadcrumb.Item className='d-blok d-md-none'>
              <span>
                <i className='bi bi-list fs-1' />
              </span>
            </Breadcrumb.Item>
            <Breadcrumb.Item className='fs-3' onClick={(e) => navigate('/carriers')}>
              Carriers
            </Breadcrumb.Item>
            <Breadcrumb.Item className='fs-3'>{carrier?.name}</Breadcrumb.Item>
          </Breadcrumb>
          <div className='d-flex align-items-center  gap-3 flex-column flex-md-row'>
            {/* <Button
              className='w-100 w-md-auto'
              onClick={handleDownload}
              disabled={loadingExport}
              variant='info'
            >
              {loadingExport ? (
                <Spinner animation='border' size='sm' />
              ) : (
                <i className='bi bi-file-earmark-arrow-down fs-3' />
              )}
              Excel base
            </Button> */}
            {/* <Button
              className='w-100 w-md-auto'
              variant='success'
              onClick={handleButtonClick}
              disabled={loadingFile}
            >
              {loadingExport || loadingFile ? (
                <Spinner animation='border' size='sm' />
              ) : (
                <i className='bi bi-file-earmark-arrow-up-fill fs-3' />
              )}
              Upload Excel
            </Button> */}
            {/* <input
              type='file'
              ref={fileInputRef}
              style={{display: 'none'}}
              accept='.xlsx,.xls'
              onChange={handleFileChange}
            /> */}
            <Button
              size='sm'
              className='w-100 w-md-auto'
              variant='primary'
              onClick={() => {
                onOpenAdd()
              }}
            >
              <i className='bi bi-plus fs-3' />
              Commission
            </Button>
          </div>
        </header>
        <Row className='policies'>
          <Col md={12} lg={12} sm={12} xl={12} className='container'>
            <div className='policies-container'>
              <div className='title-header'>
                <h3>All States</h3>
              </div>
              <div className='list-carrier  table-scrollable table-container mt-1'>
                <table className='table-scrollable table-scroll  table table-striped table-hover '>
                  <thead>
                    <tr className='fw-bolder fs-6 text-gray-800'>
                      <th className='fw-bold'>State</th>
                      {/* <th>PolicyType</th> */}
                      <th className='fw-bold'>Rate </th>
                      <th className='fw-bold'>Rate renew</th>
                      <th className='fw-bold'>Created</th>
                      <th className='fw-bold text-center'>Actions</th>
                    </tr>
                  </thead>
                  {loading ? (
                    <div className='d-flex flex-center' style={{height: '30vh'}}>
                      <Spinner animation='border' size='sm' className='me-2' />
                    </div>
                  ) : data?.commissionRateFiltered.length === 0 ? (
                    <tr>
                      <td colSpan={5}>
                        <div className='d-flex flex-center' style={{height: '30vh'}}>
                          <h4>No commission rate has been registered yet</h4>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    <tbody>
                      {data?.commissionRateFiltered.map((node) => (
                        <tr key={node.id}>
                          <td>{node.stateEU?.name ?? 'All'}</td>
                          <td>{Number(node.rateNew) > 0 ? parsePrice(node.rateNew) : '-'}</td>
                          <td>{Number(node.rateRenew) > 0 ? parsePrice(node.rateRenew) : '-'}</td>
                          <td>{moment(node.created).format('DD MMM, YYYY')}</td>
                          <td className='text-center'>
                            <ButtonGroup className='btn-sm'>
                              <Button
                                size='sm'
                                variant='secondary'
                                className='btn-sm btn-edit'
                                onClick={() => {
                                  setInfo(node)
                                  onOpenEdit()
                                }}
                              >
                                <i className='bi bi-pencil fs-4' />
                              </Button>
                              <Button
                                size='sm'
                                variant='danger'
                                className='btn-sm btn-delete'
                                onClick={() => {
                                  setInfo(node)
                                  onOpenDelete()
                                }}
                              >
                                <i className='bi bi-trash  fs-4'></i>
                              </Button>
                            </ButtonGroup>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </table>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      {isOpenEdit && info && (
        <ModalAddCommissionRate
          keyboard={false}
          backdrop='static'
          commissionId={info}
          carrierId={carrier?.id ?? ''}
          isOpen={isOpenEdit}
          onClose={onCloseEdit}
          isEdit={true}
          refetch={refetch}
        />
      )}
      {isOpenDelete && info && (
        <ModalDeleteCommissionRate
          infoEdit={info}
          isOpen={isOpenDelete}
          onClose={onCloseDelete}
          refetch={refetch}
        />
      )}
      {isOpenAdd && (
        <ModalAddCommissionRate
          keyboard={false}
          backdrop='static'
          carrierId={carrier?.id ?? ''}
          isOpen={isOpenAdd}
          isEdit={false}
          onClose={onCloseAdd}
          refetch={refetch}
        />
      )}
    </>
  )
}

// const handleDownload = async () => {
//   if (!user) return
//   const {token} = user
//   if (!token) return
//   const myHeaders = new Headers()
//   myHeaders.append('Authorization', `Bearer ${token}`)

//   const requestOptions = {
//     method: 'GET',
//     headers: myHeaders,
//   }

//   setLoadingExport(true)
//   try {
//     const res = await fetch(`${URL}/export-commissions-excel`, requestOptions)
//     if (!res.ok) throw new Error('Error al exportar')
//     const blob = await res.blob()
//     // console.log('blob', blob)
//     const url = window.URL.createObjectURL(blob)
//     const link = document.createElement('a')
//     link.href = url
//     link.download = `carriers-${moment().format('DD-MM-YY')}.xlsx`
//     document.body.appendChild(link)
//     setLoadingExport(false)
//     link.click()
//   } catch (err) {
//     setLoadingExport(false)
//     toast.error(`ERROR: ${(err as {message: string}).message}`)
//   }
// }

// const handleButtonClick = () => {
//   fileInputRef?.current?.click()
// }

// const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
//   const file = event?.target?.files?.[0]
//   if (!file) return
//   const formdata = new FormData()
//   formdata.append('0', file, file.name)
//   formdata.append('map', '{"0": ["variables.excelFile"]}')
//   const obj = {
//     query: UPLOAD_EXCEL_STR,
//     variables: {
//       excelFile: null,
//     },
//   }
//   formdata.append('operations', JSON.stringify(obj))
//   uploadFile(formdata)
// }
